// 運営コンソール全体で「日本時刻(JST)」を保証する日時ユーティリティ。
//
// 背景: バックエンド(SQLite)の datetime('now') は UTC をタイムゾーンマーカー無しで
// 返す。これをそのまま new Date(str) すると閲覧PCのローカルTZとして解釈され、
// PCが日本時刻に設定されていない環境では9時間ずれて表示される。
// そこで「UTCとして厳密にパース」→「Asia/Tokyo で描画」を一元化する。

const JST = 'Asia/Tokyo';

/** SQLite等のUTC文字列を厳密にUTCとしてパースする。無効なら null。 */
export function parseUtc(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  let s = iso;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    // 日付のみ → UTC正午に固定（JST変換で前日/翌日にずれないように）
    s = s + 'T12:00:00Z';
  } else if (!(s.endsWith('Z') || /[+-]\d\d:?\d\d$/.test(s))) {
    // 'YYYY-MM-DD HH:MM:SS'（TZ無し）→ 'YYYY-MM-DDTHH:MM:SSZ' としてUTC解釈
    s = s.replace(' ', 'T') + 'Z';
  }
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** 任意の Intl オプションで日本時刻フォーマット（timeZone は常に Asia/Tokyo に固定）。 */
export function fmtJst(iso: string | null | undefined, opts: Intl.DateTimeFormatOptions = {}, fallback = ''): string {
  const d = parseUtc(iso);
  if (!d) return fallback;
  return d.toLocaleString('ja-JP', { timeZone: JST, ...opts });
}

/** 日付＋時刻（例: 2026/07/16 15:04）。 */
export function fmtDateTimeJst(iso: string | null | undefined, fallback = ''): string {
  return fmtJst(iso, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }, fallback);
}

/** 日付＋時刻＋秒（例: 7/16 15:04:09）。監査ログ等。 */
export function fmtDateTimeSecJst(iso: string | null | undefined, fallback = ''): string {
  return fmtJst(iso, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }, fallback);
}

/** 日付のみ（例: 2026/07/16）。 */
export function fmtDateJst(iso: string | null | undefined, fallback = ''): string {
  const d = parseUtc(iso);
  if (!d) return fallback;
  return d.toLocaleDateString('ja-JP', { timeZone: JST, year: 'numeric', month: '2-digit', day: '2-digit' });
}
